window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    
    // jQuery 4.0 Compatibility Shims for legacy plugins (Slick, etc.)
    if (!jQuery.type) {
        jQuery.type = function(obj) {
            if (obj == null) return String(obj);
            return typeof obj === "object" || typeof obj === "function" ?
                Object.prototype.toString.call(obj).slice(8, -1).toLowerCase() :
                typeof obj;
        };
    }
    if (!jQuery.isFunction) {
        jQuery.isFunction = function(obj) {
            return typeof obj === "function";
        };
    }
    if (!jQuery.isNumeric) {
        jQuery.isNumeric = function(obj) {
            var type = jQuery.type(obj);
            return (type === "number" || type === "string") && !isNaN(obj - parseFloat(obj));
        };
    }

    require('jquery-mask-plugin');
    require('bootstrap');
    require('select2');
    require('slick-carousel');
    window.moment = require('moment');
    require('jquery-ui-dist/jquery-ui');
} catch (e) {
    console.error('Error loading dependencies in bootstrap.js:', e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const userApiToken = document.head.querySelector('meta[name="user-api-token"]');

if (userApiToken) {
    window.axios.defaults.headers.common.Authorization = `Bearer ${userApiToken.content}`;
}

const currentLocale = document.head.querySelector('meta[name="current-locale"]');

if (currentLocale) {
    if(!window.AsgardCMS) window.AsgardCMS = {};
    window.AsgardCMS.currentLocale = currentLocale.content;
}
